var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { TextButton } from '@hn-ui/buttons';
import { Table, } from '../../../../../Common/components/Table';
import { AssignmentsTableColumnWidth, isAssignmentCell, updateAssignmentInList, } from './tableConfig';
import { DateCell } from './DatesCell';
import { StudentsStrugglingCell } from './StudentsStrugglingCell';
import { ActionsCell } from './ActionsCell';
import { AssignmentNameCell } from './AssignmentNameCell';
import { LabelByAssignmentsFilter, } from '../../../../constants/filters';
import { useLazyCancelAssignment } from '../../../../hooks/useLazyCancelAssignment';
import { CancelModal } from '../../../../components/CancelModal';
import { useAssignmentsTableData } from './useAssignmentsTableData';
import { useAppGoogleAnalytics } from '../../../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../../../constants/analytics';
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-11vvfm9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: contents;\n\n  thead th {\n    vertical-align: bottom;\n    height: 57px;\n    padding-bottom: 12px;\n  }\n\n  tbody {\n    tr:first-child td {\n      padding-top: 15px;\n    }\n\n    td {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n"], ["\n  display: contents;\n\n  thead th {\n    vertical-align: bottom;\n    height: 57px;\n    padding-bottom: 12px;\n  }\n\n  tbody {\n    tr:first-child td {\n      padding-top: 15px;\n    }\n\n    td {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n"])));
var ScNoData = styled.div.withConfig({ displayName: "ScNoData", componentId: "sc-16godq1" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  text-align: center;\n  margin-top: 40px;\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  text-align: center;\n  margin-top: 40px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black60;
});
var ScLoadMoreBtn = styled(TextButton).withConfig({ displayName: "ScLoadMoreBtn", componentId: "sc-mp4llt" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var AssignmentsTable = function (_a) {
    var groupId = _a.groupId, assignments = _a.assignments, filter = _a.filter, onReassign = _a.onReassign, wayToObtainAccess = _a.wayToObtainAccess, props = __rest(_a, ["groupId", "assignments", "filter", "onReassign", "wayToObtainAccess"]);
    var _b = React.useState(), assignmentToCancel = _b[0], setAssignmentToCancel = _b[1];
    var _c = useLazyCancelAssignment(groupId), fetchCancelAssignment = _c[0], cancelLoading = _c[1].isLoading;
    var _d = useAssignmentsTableData({ assignments: assignments, filter: filter }), tableData = _d.tableData, showLoadMore = _d.showLoadMore, loadMore = _d.loadMore, updateAssignments = _d.updateAssignments, currentAssignments = _d.currentAssignments, filteredAssignments = _d.filteredAssignments;
    var ga = useAppGoogleAnalytics();
    var handleCancelClick = React.useCallback(function (assignment) {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: ASSIGNMENTS_EVENTS.assign_default_page_cancel_click,
        });
        setAssignmentToCancel(assignment);
    }, [ga]);
    var handleAcceptCancelAssignment = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!assignmentToCancel)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetchCancelAssignment(assignmentToCancel.id)];
                case 1:
                    _a.sent();
                    setAssignmentToCancel(undefined);
                    updateAssignments(updateAssignmentInList({
                        assignments: currentAssignments,
                        updatedAssignmentId: assignmentToCancel.id,
                        params: { status: "canceled_by_time" /* CanceledByTime */ },
                    }));
                    return [2 /*return*/];
            }
        });
    }); }, [
        assignmentToCancel,
        currentAssignments,
        fetchCancelAssignment,
        updateAssignments,
    ]);
    var handleAssignmentDetailsClick = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: ASSIGNMENTS_EVENTS.assign_default_page_assignment_click,
        });
    }, [ga]);
    var handleStatusTooltipShow = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: ASSIGNMENTS_EVENTS.assign_default_page_statustip_hover,
        });
    }, [ga]);
    var handleShowMoreClick = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: ASSIGNMENTS_EVENTS.assign_default_page_showmore_click,
        });
        loadMore();
    }, [ga, loadMore]);
    var isAssignmentsStartedAndRestricted = assignmentToCancel &&
        [
            "in_progress" /* Active */,
            "canceled_by_teacher" /* CanceledByTeacher */,
            "canceled_by_time" /* CanceledByTime */,
            "canceled" /* Canceled */,
        ].includes(assignmentToCancel.status) &&
        wayToObtainAccess !== 'unlocked';
    var columns = React.useMemo(function () {
        return [
            {
                id: 'Assignment name',
                Header: 'Assignment name',
                Cell: AssignmentNameCell,
                disableSortBy: true,
                style: {
                    minWidth: AssignmentsTableColumnWidth.NAME,
                    maxWidth: AssignmentsTableColumnWidth.NAME,
                },
            },
            {
                id: 'Dates',
                Header: 'Dates',
                Cell: DateCell,
                disableSortBy: true,
                style: {
                    minWidth: AssignmentsTableColumnWidth.DATES,
                    maxWidth: AssignmentsTableColumnWidth.DATES,
                },
            },
            {
                id: 'Students completed / assigned',
                Header: 'Students completed / assigned',
                Cell: function (_a) {
                    var original = _a.row.original;
                    return isAssignmentCell(original)
                        ? original.studentsCompleted + " / " + original.studentsAssigned
                        : null;
                },
                disableSortBy: true,
                style: {
                    minWidth: AssignmentsTableColumnWidth.STUDENTS_COMPLETED,
                    maxWidth: AssignmentsTableColumnWidth.STUDENTS_COMPLETED,
                    paddingRight: 66,
                },
            },
            {
                id: 'Students needing intervention',
                Header: 'Students needing intervention',
                Cell: StudentsStrugglingCell,
                disableSortBy: true,
                style: {
                    minWidth: AssignmentsTableColumnWidth.STUDENTS_STRUGGLING,
                    maxWidth: AssignmentsTableColumnWidth.STUDENTS_STRUGGLING,
                },
            },
            {
                id: 'Actions',
                Cell: function (cell) { return (_jsx(ActionsCell, __assign({}, cell, { onCancelClick: handleCancelClick, onReassignClick: onReassign, onDetailsClick: handleAssignmentDetailsClick }), void 0)); },
                disableSortBy: true,
                style: {
                    minWidth: AssignmentsTableColumnWidth.ACTIONS,
                    maxWidth: AssignmentsTableColumnWidth.ACTIONS,
                },
            },
        ];
    }, [
        handleAssignmentDetailsClick,
        handleCancelClick,
        onReassign,
        handleStatusTooltipShow,
    ]);
    return (_jsxs(ScWrapper, { children: [_jsx(Table, __assign({ columns: columns, data: tableData, isFlexLayout: false, stickyHeader: true, testId: 'assignments-table' }, props), void 0), filter && filteredAssignments.length === 0 && (_jsx(ScNoData, { children: "There are no assignments " + LabelByAssignmentsFilter[filter].toLowerCase() }, void 0)), showLoadMore && (_jsx(ScLoadMoreBtn, __assign({ onClick: handleShowMoreClick }, { children: "View more previous assignments" }), void 0)), _jsx(CancelModal, { "data-testid": 'assignments-table-cancel-modal', open: Boolean(assignmentToCancel), title: "Cancel assignment " + (assignmentToCancel === null || assignmentToCancel === void 0 ? void 0 : assignmentToCancel.name) + "?", subtitle: isAssignmentsStartedAndRestricted ? (_jsxs(_Fragment, { children: [_jsx("b", { children: "Note!" }, void 0), " This assignment has already been started", _jsx("br", {}, void 0), "by a student and counted toward your free assignment limit.", _jsx("br", {}, void 0), "Do you still want to delete the assignment?"] }, void 0)) : ('The assignment will be canceled for all students it was assigned to'), onCancelClick: handleAcceptCancelAssignment, onCloseClick: function () { return setAssignmentToCancel(undefined); }, loading: cancelLoading }, void 0)] }, void 0));
};
export { AssignmentsTable };
var templateObject_1, templateObject_2, templateObject_3;
